// Validações com as mensagens exatas do protótipo (doSubmit 1736, anexarVistoria 1530,
// doLogin/doCriarConta, gestão e reprovação). Devolvem a primeira mensagem de erro, ou null.

import type { ItemChecklist, Respostas } from './tipos.js';

export const LIMITE_ANEXO_BYTES = 8 * 1024 * 1024;
export const MAX_FOTOS_GERAIS = 20;

const RE_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function emailValido(e: string | null | undefined): boolean {
  return RE_EMAIL.test(String(e ?? '').trim());
}

export function emailLbx(e: string | null | undefined): boolean {
  return /^[^\s@]+@lbx\.com\.br$/i.test(String(e ?? '').trim());
}

export interface DadosEnvio {
  auditor: string;
  email: string;
}

/** Erro que impede o envio da vistoria. */
export function erroDoEnvio(d: DadosEnvio): string | null {
  if (!String(d.auditor ?? '').trim()) return 'Informe o nome do responsavel.';
  const e = String(d.email ?? '').trim();
  if (!e) return 'Informe seu e-mail.';
  if (!RE_EMAIL.test(e)) return 'E-mail inválido.';
  return null;
}

export function itensSemResposta(itens: readonly ItemChecklist[], r: Respostas): number {
  return itens.filter((it) => !r[it.n]?.s).length;
}

/** Texto do confirm de itens em branco. */
export function avisoItensSemResposta(n: number): string | null {
  return n > 0 ? `${n} item(s) sem preencher. Continuar?` : null;
}

export function erroDoAnexo(bytes: number): string | null {
  if (bytes > LIMITE_ANEXO_BYTES) {
    return `Arquivo muito grande (${(bytes / 1024 / 1024).toFixed(1)} MB). O limite é 8 MB.`;
  }
  return null;
}

export function erroDaReprovacao(motivo: string | null | undefined): string | null {
  return String(motivo ?? '').trim() ? null : 'O motivo é obrigatório.';
}

export function erroDoContrato(inicio: string | null, fim: string | null): string | null {
  if (inicio && fim && fim < inicio) return 'A data de fim não pode ser anterior à data de início.';
  return null;
}

export function erroDoGasto(valor: number): string | null {
  return valor > 0 ? null : 'Informe um valor maior que zero.';
}

export function erroDoItemInventario(item: string): string | null {
  return String(item ?? '').trim() ? null : 'Informe o item.';
}

export function erroDaObra(nome: string): string | null {
  return String(nome ?? '').trim() ? null : 'Informe o nome da obra.';
}

export function erroDoAlojamento(nome: string): string | null {
  return String(nome ?? '').trim() ? null : 'Preencha o endereço do alojamento.';
}

/** Mensagem de "Editar alojamento" (o protótipo usa texto diferente do de "Adicionar"). */
export function erroDaEdicaoDeAlojamento(nome: string): string | null {
  return String(nome ?? '').trim() ? null : 'Informe o endereço do alojamento.';
}

export function erroDoItemDeChecklist(descricao: string): string | null {
  return String(descricao ?? '').trim() ? null : 'Digite a descrição.';
}

/** Quantidade do inventário: inteiro > 0, senão 1 (protótipo: parseInt + fallback). */
export function quantidadeDoInventario(entrada: string | number): number {
  const q = Number.parseInt(String(entrada), 10);
  return q > 0 ? q : 1;
}
